import { render, staticRenderFns } from "./ModalProcessoArtefato.vue?vue&type=template&id=e0735ff6"
import script from "./ModalProcessoArtefato.vue?vue&type=script&lang=js"
export * from "./ModalProcessoArtefato.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessoArtefato.vue?vue&type=style&index=0&id=e0735ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports